import { getOidcConfig } from '@/config/oidcConfig';
import { UserManager } from 'oidc-client-ts';
import { useEffect } from 'react';

/**
 * Login Callback Component
 * 
 * Handles OAuth callback from Access Identity for both authentication modes.
 * 
 * NOTE: react-oidc-context automatically processes the callback when it detects
 * authorization code in the URL. We just need to wait for completion and navigate.
 */
export default function NativeTabLoginCallback() {
  useEffect(() => {
    const handleCallback = async () => {
      try {
        const oidcConfig = getOidcConfig();
        const userManager = new UserManager({
          ...oidcConfig,
          authority: ''
        });
        
        await userManager.signinCallback();
      } catch (error) {
        console.error('Error during silent callback processing:', error);
      }
    };

    handleCallback();
  }, []);

  // Show loading indicator during callback processing
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completing authentication...</p>
      </div>
    </div>
  );
}
